var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("article", { staticClass: "box" }, [
          _c("div", { staticClass: "columns mb-0 pb-0" }, [
            _c("div", { staticClass: "column pb-0" }, [
              _c("p", { staticClass: "title mb-2" }, [
                _vm._v(" Assessments "),
                _c(
                  "button",
                  {
                    staticClass: "button is-small is-info ml-2 title-align",
                    on: { click: _vm.openSummaryModal },
                  },
                  [_vm._m(0), _c("span", [_vm._v(" View Summary ")])]
                ),
              ]),
            ]),
          ]),
          _vm.assessments.length > 0 || _vm.numItemsChanged > 0
            ? _c("div", [
                _c("div", { staticClass: "tabs" }, [
                  _c(
                    "ul",
                    [
                      _vm._l(_vm.assessments, function (assessment) {
                        return _c(
                          "li",
                          {
                            key: assessment.assessmentID,
                            class: {
                              "is-active":
                                _vm.selectedAssessment?.assessmentID ===
                                assessment.assessmentID,
                              "tab-disabled":
                                _vm.selectedAssessment?.assessmentID !==
                                  assessment.assessmentID &&
                                (_vm.editAuthorisedMode || _vm.editQuotedMode),
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.selectAssessment(assessment)
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _c(
                                    "span",
                                    { staticClass: "has-badge-child-offset2" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentAuthorisedQuoteLabel(
                                            assessment,
                                            true
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  assessment?.authorisedAssessment &&
                                  assessment.authorisedAssessment.isDraft !==
                                    true
                                    ? _c(
                                        "span",
                                        { staticClass: "tag is-success icon" },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-check",
                                          }),
                                        ]
                                      )
                                    : assessment?.submittedAssessment
                                    ? _c(
                                        "span",
                                        { staticClass: "tag is-warning" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              assessment.submittedAssessment
                                                ? assessment.submittedAssessment
                                                    .assessmentQuoteItems.length
                                                : 0
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]
                        )
                      }),
                      _vm.numItemsChanged > 0
                        ? _c(
                            "li",
                            {
                              class: {
                                "is-active":
                                  _vm.selectedAssessment?.assessmentID ===
                                  _vm.draftAssessment.assessmentID,
                                "tab-disabled":
                                  _vm.selectedAssessment?.assessmentID !==
                                    _vm.draftAssessment.assessmentID &&
                                  (_vm.editAuthorisedMode ||
                                    _vm.editQuotedMode),
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectDraftAssessment()
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "has-badge-child-offset2",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.assessments.length === 0
                                              ? "MAIN"
                                              : `SUPP-${_vm.assessments.length}`
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "tag",
                                        class: `is-${_vm.$theme.name}`,
                                      },
                                      [_vm._v(_vm._s(_vm.numItemsChanged))]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  !_vm.assessments[0]?.authorisedAssessment &&
                  (_vm.editAuthorisedMode || _vm.editQuotedMode)
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "button is-primary tooltip is-tooltip-topright",
                          attrs: { "data-tooltip": "Edit rates" },
                          on: { click: _vm.openEditRatesModal },
                        },
                        [_vm._m(1), _c("span", [_vm._v("Edit Rates")])]
                      )
                    : _vm._e(),
                ]),
                _c(
                  "div",
                  { staticClass: "mt-2" },
                  [
                    _c("div", { staticClass: "columns is-gapless mb-0" }, [
                      _c("div", { staticClass: "column" }, [
                        _c("p", [
                          _c("span", [
                            _c(
                              "span",
                              { staticClass: "has-text-weight-semibold" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currentAuthorisedQuoteLabel(
                                        _vm.selectedAssessment
                                      )
                                    ) +
                                    " Requested Value: "
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "has-text-weight-semibold" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        _vm.selectedQuotedValue,
                                        _vm.$userInfo.locale
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _vm.selectedAssessment.authorisedAssessment
                            ? _c("span", { staticClass: "ml-6" }, [
                                _c(
                                  "span",
                                  { staticClass: "has-text-weight-semibold" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.currentAuthorisedQuoteLabel(
                                            _vm.selectedAssessment
                                          )
                                        ) +
                                        " Authorised Value: "
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "has-text-weight-semibold",
                                    class: _vm.totalAuthorisedColourClass,
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$filters.formatCurrency(
                                            _vm.selectedAuthorisedValue,
                                            _vm.$userInfo.locale
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      !_vm.isReadonly
                        ? _c(
                            "div",
                            { staticClass: "control is-pulled-right" },
                            [
                              _c("div", { staticClass: "field-body" }, [
                                _c("div", { staticClass: "field mr-2" }, [
                                  _c("div", { staticClass: "buttons" }, [
                                    !(
                                      _vm.editAuthorisedMode ||
                                      _vm.editQuotedMode
                                    ) &&
                                    _vm.isAssessmentSubmitted &&
                                    (!_vm.isEstimageEnabled ||
                                      _vm.$userInfo.isSupportUser) &&
                                    !_vm.isAssessmentAuthorised
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-secondary tooltip is-tooltip-topright is-transparent",
                                            attrs: {
                                              "data-tooltip":
                                                "Cancel the last request to authority",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openCancelRequestConfirmModal()
                                              },
                                            },
                                          },
                                          [
                                            _vm._m(2),
                                            _c("span", [
                                              _vm._v("Cancel Request"),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    !(
                                      _vm.editAuthorisedMode ||
                                      _vm.editQuotedMode
                                    ) &&
                                    _vm.isAssessmentAuthorised &&
                                    _vm.selectedAssessment.subQuoteNo ===
                                      _vm.assessments.length - 1 &&
                                    _vm.selectedAssessment.isInvoiced !==
                                      true &&
                                    (!_vm.isEstimageEnabled ||
                                      _vm.$userInfo.isSupportUser)
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-secondary tooltip is-tooltip-topright is-transparent",
                                            attrs: {
                                              "data-tooltip":
                                                "Cancel the last authority",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openCancelAuthorityConfirmModal()
                                              },
                                            },
                                          },
                                          [
                                            _vm._m(3),
                                            _c("span", [
                                              _vm._v(
                                                "Cancel " +
                                                  _vm._s(
                                                    _vm.currentAuthorisedQuoteLabel(
                                                      _vm.selectedAssessment
                                                    )
                                                  ) +
                                                  " Authority"
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    !(
                                      _vm.editAuthorisedMode ||
                                      _vm.editQuotedMode
                                    ) &&
                                    !_vm.isAssessmentSubmitted &&
                                    !_vm.isAssessmentAuthorised &&
                                    _vm.isQuoteAuthorised
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-secondary tooltip is-tooltip-topright is-transparent",
                                            attrs: {
                                              "data-tooltip":
                                                "Revert to last authority",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.openRevertConfirmModal()
                                              },
                                            },
                                          },
                                          [
                                            _vm._m(4),
                                            _c("span", [
                                              _vm._v(
                                                "Revert to " +
                                                  _vm._s(
                                                    _vm.lastAuthorisedQuoteLabel(
                                                      _vm.selectedAssessment
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.editAuthorisedMode || _vm.editQuotedMode
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-secondary tooltip is-tooltip-topright is-transparent",
                                            attrs: { "data-tooltip": "Cancel" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancel()
                                              },
                                            },
                                          },
                                          [
                                            _vm._m(5),
                                            _c("span", [_vm._v("Cancel")]),
                                          ]
                                        )
                                      : _vm._e(),
                                    !(
                                      _vm.editAuthorisedMode ||
                                      _vm.editQuotedMode
                                    ) &&
                                    (!_vm.isAssessmentSubmitted ||
                                      _vm.isEstimageEnabled) &&
                                    !_vm.isAssessmentAuthorised &&
                                    _vm.isPreviousQuoteAuthorised
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-info is-outlined tooltip is-tooltip-topright",
                                            attrs: {
                                              "data-tooltip": "Submit request",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editMode(false)
                                              },
                                            },
                                          },
                                          [
                                            !_vm.isAssessmentSubmitted
                                              ? _c("div", [
                                                  _vm._m(6),
                                                  _vm.insurer.arnie
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "Send Request to Arnie"
                                                        ),
                                                      ])
                                                    : _vm.isEstimageEnabled &&
                                                      !_vm.isAssessmentSubmitted
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "Send Request to EstImage"
                                                        ),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          "Request Authority"
                                                        ),
                                                      ]),
                                                ])
                                              : _vm._e(),
                                            _vm.isEstimageEnabled &&
                                            _vm.isAssessmentSubmitted &&
                                            !_vm.isAssessmentAuthorised
                                              ? _c("div", [
                                                  _vm._m(7),
                                                  _c("span", [
                                                    _vm._v("Resend Request"),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    !(
                                      _vm.editAuthorisedMode ||
                                      _vm.editQuotedMode
                                    ) &&
                                    _vm.doesUserAllowedToAuthorise &&
                                    (_vm.selectedAssessmentStatus ===
                                      "submitted" ||
                                      (_vm.selectedAssessmentStatus ===
                                        "draft" &&
                                        !_vm.insurer.arnie &&
                                        !_vm.isEstimageEnabled &&
                                        _vm.isPreviousQuoteAuthorised) ||
                                      (_vm.selectedAssessmentStatus ===
                                        "authorised" &&
                                        _vm.nextSelectedAssessmentStatus ==
                                          "draft" &&
                                        _vm.isEstimageEnabled))
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-info is-outlined tooltip is-tooltip-topright",
                                            attrs: {
                                              "data-tooltip":
                                                "Submit authorise",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editMode(true)
                                              },
                                            },
                                          },
                                          [
                                            _vm._m(8),
                                            _vm.isAssessmentAuthorised &&
                                            _vm.isEstimageEnabled
                                              ? _c("span", [
                                                  _vm._v("Update Authority"),
                                                ])
                                              : _c("span", [
                                                  _vm._v("Authorise"),
                                                ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.editAuthorisedMode
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-success tooltip is-tooltip-topright",
                                            attrs: {
                                              disabled: !_vm.hasAllItemChecked,
                                              "data-tooltip":
                                                "Autorise selected items",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.authorise()
                                              },
                                            },
                                          },
                                          [
                                            _vm._m(9),
                                            _c("span", [
                                              _vm._v("Confirm Authorise"),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.editQuotedMode &&
                                    !_vm.editAuthorisedMode
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button is-success tooltip is-tooltip-topright",
                                            attrs: {
                                              disabled: !_vm.hasAllItemChecked,
                                              "data-tooltip":
                                                "Request selected items",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.confirmSendRequest()
                                              },
                                            },
                                          },
                                          [
                                            _vm._m(10),
                                            _c("span", [
                                              _vm._v("Confirm Send Request"),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "columns mt-2" }, [
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Quote Status:"),
                          ]),
                          _c("div", [
                            _vm.selectedAssessment.isInvoiced
                              ? _c("div", { staticClass: "tag is-success" }, [
                                  _c("i", {
                                    staticClass:
                                      "icon mdi mdi-check-circle-outline",
                                  }),
                                  _vm._v(" Invoiced "),
                                ])
                              : _vm.isAssessmentAuthorised
                              ? _c("div", { staticClass: "tag is-success" }, [
                                  _vm._v(" Authorised "),
                                ])
                              : _vm.isAssessmentSubmitted
                              ? _c("div", { staticClass: "tag is-warning" }, [
                                  _vm._v(" Request Sent "),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass: "tag",
                                    class: `is-${_vm.$theme.name}`,
                                  },
                                  [_vm._v(" Draft ")]
                                ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Claim Number:"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _vm.editAuthorisedMode
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.innerValue.claimNo,
                                      expression: "innerValue.claimNo",
                                    },
                                  ],
                                  staticClass: "input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Claim No",
                                  },
                                  domProps: { value: _vm.innerValue.claimNo },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.innerValue,
                                        "claimNo",
                                        $event.target.value
                                      )
                                    },
                                  },
                                })
                              : _c("div", [
                                  _vm._v(_vm._s(_vm.innerValue.claimNo)),
                                ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Date Requested:"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedAssessment?.submittedAssessment
                                    ? _vm.$filters.formatDateTimezone(
                                        _vm.selectedAssessment
                                          ?.submittedAssessment?.createdDate,
                                        _vm.$userInfo.locale
                                      )
                                    : "-"
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Date Authorised:"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedAssessment?.authorisedAssessment
                                    ? _vm.$filters.formatDateTimezone(
                                        _vm.selectedAssessment.authorisedDate ??
                                          _vm.selectedAssessment
                                            ?.authorisedAssessment?.createdDate,
                                        _vm.$userInfo.locale
                                      )
                                    : "-"
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Assessor Name:"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _vm.editAuthorisedMode
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.selectedAssessment.assessorName,
                                      expression:
                                        "selectedAssessment.assessorName",
                                    },
                                  ],
                                  staticClass: "input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Assessor Name",
                                  },
                                  domProps: {
                                    value: _vm.selectedAssessment.assessorName,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.selectedAssessment,
                                        "assessorName",
                                        $event.target.value
                                      )
                                    },
                                  },
                                })
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.selectedAssessment?.assessorName
                                        ? _vm.selectedAssessment.assessorName
                                        : "-"
                                    )
                                  ),
                                ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Excess Amount:"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatCurrency(
                                    _vm.innerValue.excess,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    (_vm.editAuthorisedMode || _vm.editQuotedMode) &&
                    !_vm.isAllSelected
                      ? _c(
                          "div",
                          { staticClass: "is-fullwidth mb-3 select-all-box" },
                          [
                            _c(
                              "div",
                              { staticClass: "mr-3 ml-3 has-vertical-middle" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pretty p-icon p-curve p-smooth m-0 p-bigger",
                                  },
                                  [
                                    _c("input", {
                                      attrs: { type: "checkbox" },
                                      domProps: { value: _vm.isAllSelected },
                                      on: { change: _vm.onSelectAllChanged },
                                    }),
                                    _vm._m(11),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._l(_vm.labourCategories, function (itemType) {
                      return _c(
                        "div",
                        { key: itemType },
                        [
                          itemType !== "PAINT"
                            ? _c("authorise-labour", {
                                key:
                                  _vm.selectedAssessment.assessmentID +
                                  itemType,
                                staticClass: "mb-5",
                                attrs: {
                                  value: _vm.innerValue,
                                  vehicle: _vm.innerVehicle,
                                  "assessment-items":
                                    _vm.selectedAssessmentItems,
                                  "item-type": itemType,
                                  "edit-authorised-mode":
                                    _vm.editAuthorisedMode,
                                  "edit-quoted-mode": _vm.editQuotedMode,
                                  "is-draft": _vm.selectedAssessment.isDraft,
                                  "select-all": _vm.isCategorySelected.find(
                                    (i) => i.itemType === itemType
                                  ).selected,
                                },
                                on: {
                                  "select-all-changed":
                                    _vm.onCategorySelectChange,
                                  "update-assessment-item":
                                    _vm.updateDraftAssessment,
                                  "add-assessment-item":
                                    _vm.addItemToDraftAssessment,
                                },
                              })
                            : _vm._e(),
                          itemType == "PAINT"
                            ? _c("authorise-opg", {
                                key:
                                  _vm.selectedAssessment.assessmentID +
                                  itemType,
                                staticClass: "mb-5",
                                attrs: {
                                  value: _vm.innerValue,
                                  vehicle: _vm.innerVehicle,
                                  "assessment-items":
                                    _vm.selectedAssessmentItems,
                                  "item-type": itemType,
                                  "edit-authorised-mode":
                                    _vm.editAuthorisedMode,
                                  "edit-quoted-mode": _vm.editQuotedMode,
                                  "is-draft": _vm.selectedAssessment.isDraft,
                                  "select-all": _vm.isCategorySelected.find(
                                    (i) => i.itemType === itemType
                                  ).selected,
                                },
                                on: {
                                  "select-all-changed":
                                    _vm.onCategorySelectChange,
                                  "update-assessment-item":
                                    _vm.updateDraftAssessment,
                                  "add-assessment-item":
                                    _vm.addItemToDraftAssessment,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    _vm._l(_vm.partCategories, function (itemType) {
                      return _c(
                        "div",
                        { key: itemType },
                        [
                          _c("authorise-part", {
                            key: _vm.selectedAssessment.assessmentID + itemType,
                            staticClass: "mb-5",
                            attrs: {
                              value: _vm.innerValue,
                              vehicle: _vm.innerVehicle,
                              "assessment-items": _vm.selectedAssessmentItems,
                              "item-type": itemType,
                              "edit-authorised-mode": _vm.editAuthorisedMode,
                              "edit-quoted-mode": _vm.editQuotedMode,
                              "is-draft": _vm.selectedAssessment.isDraft,
                              "select-all": _vm.isCategorySelected.find(
                                (i) => i.itemType === itemType
                              ).selected,
                            },
                            on: {
                              "select-all-changed": _vm.onCategorySelectChange,
                              "update-assessment-item":
                                _vm.updateDraftAssessment,
                              "add-assessment-item":
                                _vm.addItemToDraftAssessment,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm._l(_vm.miscCategories, function (itemType) {
                      return _c(
                        "div",
                        { key: itemType },
                        [
                          _c("authorise-misc", {
                            key: _vm.selectedAssessment.assessmentID + itemType,
                            staticClass: "mb-5",
                            attrs: {
                              value: _vm.innerValue,
                              vehicle: _vm.innerVehicle,
                              "assessment-items": _vm.selectedAssessmentItems,
                              "item-type": itemType,
                              "edit-authorised-mode": _vm.editAuthorisedMode,
                              "edit-quoted-mode": _vm.editQuotedMode,
                              "is-draft": _vm.selectedAssessment.isDraft,
                              "select-all": _vm.isCategorySelected.find(
                                (i) => i.itemType === itemType
                              ).selected,
                            },
                            on: {
                              "select-all-changed": _vm.onCategorySelectChange,
                              "update-assessment-item":
                                _vm.updateDraftAssessment,
                              "add-assessment-item":
                                _vm.addItemToDraftAssessment,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm._l(_vm.subletCategories, function (itemType) {
                      return _c(
                        "div",
                        { key: itemType },
                        [
                          _c("authorise-sublet", {
                            key: _vm.selectedAssessment.assessmentID + itemType,
                            staticClass: "mb-5",
                            attrs: {
                              value: _vm.innerValue,
                              vehicle: _vm.innerVehicle,
                              "assessment-items": _vm.selectedAssessmentItems,
                              "item-type": itemType,
                              "edit-authorised-mode": _vm.editAuthorisedMode,
                              "edit-quoted-mode": _vm.editQuotedMode,
                              "is-draft": _vm.selectedAssessment.isDraft,
                              "select-all": _vm.isCategorySelected.find(
                                (i) => i.itemType === itemType
                              ).selected,
                            },
                            on: {
                              "select-all-changed": _vm.onCategorySelectChange,
                              "update-assessment-item":
                                _vm.updateDraftAssessment,
                              "add-assessment-item":
                                _vm.addItemToDraftAssessment,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm.selectedAssessmentItems?.length === 0
                      ? _c("div", [_vm._m(12)])
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.isEditRateModalVisible
        ? _c("edit-rates-modal", {
            attrs: {
              "show-icon": true,
              active: _vm.isEditRateModalVisible,
              "quote-values": _vm.innerValue,
              "vehicle-values": _vm.innerVehicle,
            },
            on: {
              "update:active": function ($event) {
                _vm.isEditRateModalVisible = $event
              },
              "apply-rates": _vm.applyRates,
              close: function ($event) {
                _vm.isEditRateModalVisible = false
              },
            },
          })
        : _vm._e(),
      _vm.isRequestConfirmModalVisible
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isRequestConfirmModalVisible,
                "ok-text": "Authorise",
                "ok-class": "is-success",
                "cancel-text": "Cancel",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isRequestConfirmModalVisible = $event
                },
                ok: function ($event) {
                  return _vm.authorise()
                },
                cancel: function ($event) {
                  _vm.isRequestConfirmModalVisible = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Confirm to request"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    " Are you sure you want to request the selected items? "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isRevertConfirmModalActive
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isRevertConfirmModalActive,
                "ok-text": `Revert to ${_vm.lastAuthorisedQuoteLabel(
                  _vm.selectedAssessment
                )}`,
                "ok-class": "is-danger",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isRevertConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.revertToAuthority(true)
                },
                cancel: function ($event) {
                  _vm.isRevertConfirmModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Revert to Authority"),
              ]),
              _c(
                "div",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c("p", [
                    _vm._v(
                      " Are you sure you want to revert to the last authority? "
                    ),
                    _c("strong", { staticClass: "has-text-danger" }, [
                      _vm._v(
                        "All changes " +
                          _vm._s(
                            _vm.currentAuthorisedQuoteLabel(
                              _vm.selectedAssessment
                            )
                          ) +
                          " will be lost."
                      ),
                    ]),
                  ]),
                  _c("br"),
                  _c("ul", [
                    _c("li", [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-delete" }),
                      ]),
                      _vm._v(" New items will be "),
                      _c("strong", [_vm._v(" removed")]),
                      _vm._v(". "),
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-restore" }),
                      ]),
                      _vm._v(" Deleted items will be "),
                      _c("strong", [_vm._v(" restored")]),
                      _vm._v(". "),
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-undo" }),
                      ]),
                      _vm._v(" Modified items will be "),
                      _c("strong", [_vm._v("revert")]),
                      _vm._v(" to original values. "),
                    ]),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isCancelAuthorityConfirmModalActive
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isCancelAuthorityConfirmModalActive,
                "show-close": true,
                "show-cancel": false,
                "cancel-text": `Revert to ${_vm.lastAuthorisedQuoteLabel(
                  _vm.selectedAssessment
                )}`,
                "cancel-class": "is-danger",
                "ok-class": "is-danger",
                "ok-text": `Cancel ${_vm.currentAuthorisedQuoteLabel(
                  _vm.selectedAssessment
                )} Authority`,
                "close-text": "Close",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isCancelAuthorityConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.cancelAuthority(true)
                },
                cancel: function ($event) {
                  return _vm.cancelAuthority(false)
                },
                close: function ($event) {
                  _vm.isCancelAuthorityConfirmModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Cancel last Authority"),
              ]),
              _c(
                "div",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c("p", [
                    _vm._v(" Are you sure you want to cancel "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.currentAuthorisedQuoteLabel(
                            _vm.selectedAssessment
                          )
                        )
                      ),
                    ]),
                    _vm._v(" authority? "),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isCancelRequestConfirmModalActive
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isCancelRequestConfirmModalActive,
                "show-close": true,
                "show-cancel": false,
                "cancel-text": `Revert to ${_vm.lastAuthorisedQuoteLabel(
                  _vm.selectedAssessment
                )}`,
                "cancel-class": "is-danger",
                "ok-class": "is-danger",
                "ok-text": `Cancel ${_vm.currentAuthorisedQuoteLabel(
                  _vm.selectedAssessment
                )} Request`,
                "close-text": "Close",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isCancelRequestConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.cancelRequest(true)
                },
                cancel: function ($event) {
                  return _vm.cancelRequest(false)
                },
                close: function ($event) {
                  _vm.isCancelRequestConfirmModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Cancel last Request"),
              ]),
              _c(
                "div",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c("p", [
                    _vm._v(" Are you sure you want to cancel "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.currentAuthorisedQuoteLabel(
                            _vm.selectedAssessment
                          )
                        )
                      ),
                    ]),
                    _vm._v(" request? "),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isConfrimManualAuthoriseModalActive
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfrimManualAuthoriseModalActive,
                "show-close": true,
                "show-cancel": false,
                "ok-class": "is-info",
                "ok-text": "Continue",
                "close-text": "Close",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfrimManualAuthoriseModalActive = $event
                },
                ok: function ($event) {
                  return _vm.manualSendQuoteEstImage()
                },
                close: function ($event) {
                  _vm.isConfrimManualAuthoriseModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Important"),
              ]),
              _c(
                "div",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c(
                    "notification-box",
                    { staticClass: "mb-3", attrs: { type: "warning" } },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "is-size-6",
                          attrs: { slot: "text-content" },
                          slot: "text-content",
                        },
                        [
                          _vm._v("Please check all items in "),
                          _c("b", [_vm._v("FlexiQuote")]),
                          _vm._v(" and "),
                          _c("b", [_vm._v("EstImage")]),
                          _vm._v(" match."),
                        ]
                      ),
                    ]
                  ),
                  _c("p", [
                    _vm._v(
                      " Click continue to change the FlexiQuote quote status to "
                    ),
                    _c("b", [_vm._v('"Request Sent"')]),
                    _vm._v(". "),
                  ]),
                  _c("p", [
                    _c("b", [_vm._v("Please Note:")]),
                    _vm._v(
                      " The EstImage quote status will not be updated as the quote has already been sent in the system. "
                    ),
                  ]),
                  _c("br"),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.isSummaryModalVisible
        ? _c("quote-detail-assessment-summary-modal", {
            attrs: {
              "show-icon": true,
              active: _vm.isSummaryModalVisible,
              value: _vm.innerValue,
            },
            on: {
              "update:active": function ($event) {
                _vm.isSummaryModalVisible = $event
              },
              close: function ($event) {
                _vm.isSummaryModalVisible = false
              },
            },
          })
        : _vm._e(),
      _vm.isEstimageSendModalActive
        ? _c("est-image-send-quote-modal", {
            attrs: {
              active: _vm.isEstimageSendModalActive,
              value: _vm.innerValue,
              "modal-type": "SendQuoteWithConfirm",
              title: "Send Quote to EstImage",
              "icon-name": "mdi-upload",
            },
            on: {
              "update:active": function ($event) {
                _vm.isEstimageSendModalActive = $event
              },
              close: function ($event) {
                return _vm.closeSendEstimage()
              },
              submit: _vm.sendEstImageQuote,
            },
          })
        : _vm._e(),
      _vm.isQuoteExportModalActive
        ? _c("quote-export-modal", {
            attrs: {
              active: _vm.isQuoteExportModalActive,
              vehicle: _vm.vehicle,
              "default-email": _vm.insurerDefaultEmail,
              "send-email-mode": true,
              assessment: _vm.selectedAssessment,
            },
            on: {
              "update:active": function ($event) {
                _vm.isQuoteExportModalActive = $event
              },
              close: _vm.closeArnieSendQuoteModal,
              sent: _vm.sentToArnie,
            },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-eye" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-pencil" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-undo" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-file-send" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-refresh" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-playlist-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-playlist-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-file-send" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", { staticClass: "has-text-info" }, [
        _vm._v("Select All Items"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "mt-5 mb-3" }, [
      _c("div", { staticClass: "content has-text-grey has-text-centered" }, [
        _c("span", { attrs: { icon: "icon is-large" } }, [
          _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
        ]),
        _c("p", [_vm._v("There is no Item in this assessment.")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }